<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-14 14:12:46
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/SetImgMultOrOne.vue
-->
<template>
    <div class="mt-5">
        <div class="grid grid-cols-2 gap-1 sm:gap-2">
            <button
                v-for="item in typeEnums"
                :key="item.value"
                @click="handleTypeClick(item.value)"
                :class="[
                    'flex h-[36px] border bg-tool-default-black border-transparent flex-col items-center justify-center gap-[10px] rounded-[10px] text-sm duration-300 p-[10px]',
                    isOptionDisabled(item.value)
                        ? 'cursor-not-allowed opacity-50 border-white/[.06]'
                        : 'cursor-pointer',
                    !isOptionDisabled(item.value) && !isOptionActive(item.value)
                        ? 'border-white/[.06] hover:border-white/30'
                        : '',
                    !isOptionDisabled(item.value) && isOptionActive(item.value)
                        ? '!border-white/50 !bg-white/10'
                        : '',
                ]"
            >
                <span
                    :class="[
                        'text-xs font-medium transition-colors duration-200',
                        isOptionActive(item.value) && !isOptionDisabled(item.value)
                            ? 'text-white'
                            : 'text-not-active',
                    ]"
                >
                    {{ item.name }}
                </span>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'

const props = withDefaults(
    defineProps<{
        /** 禁用多分镜选项（与尾帧互斥时使用） */
        disable_multiple_frames?: boolean
        /** Seedance 全能参考模型下切换 tab 的顺序与文案 */
        allround_model?: boolean
        /** 覆盖 single_frame 选项文案 */
        single_frame_label?: string
        /** single_frame 选项是否直接映射到首尾帧模式 */
        single_frame_requires_frame_end?: boolean
    }>(),
    {
        disable_multiple_frames: false,
        allround_model: false,
        single_frame_label: '',
        single_frame_requires_frame_end: false,
    }
)

const { t, locale } = useI18n()
const frame_end_mode = defineModel('frame_end_mode', {
    type: Boolean,
    default: false,
})

const getSingleFrameLabel = () => {
    return props.single_frame_label || t('tools.frameToVideoTitle')
}

const typeEnums = computed(() => {
    void locale.value
    if (props.allround_model) {
        return [
            {
                name: t('workbench.seedanceVideoModes.allRound'),
                value: 'multiple_frames',
            },
            {
                name: getSingleFrameLabel(),
                value: 'single_frame',
            },
        ]
    }
    return [
        {
            name: getSingleFrameLabel(),
            value: 'single_frame',
        },
        {
            name: t('tools.IngredientsToVideo'),
            value: 'multiple_frames',
        },
    ]
})

const image_type = defineModel('image_type')

const isOptionDisabled = (value: string) => {
    return value === 'multiple_frames' && props.disable_multiple_frames
}

const isOptionActive = (value: string) => {
    if (value === 'single_frame' && props.single_frame_requires_frame_end) {
        return image_type.value === 'single_frame' && !!frame_end_mode.value
    }
    return image_type.value === value
}

const handleTypeClick = (value: string) => {
    if (isOptionDisabled(value)) return
    image_type.value = value
    if (props.single_frame_requires_frame_end) {
        frame_end_mode.value = value === 'single_frame'
    }
}
</script>
<style scoped lang="less"></style>
